export const constants = {
    laundryType: 'laundry',
    balconyType: 'balcony'
}